// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const RegisteredConditionsTable: MarkdocTagRegistration = {
  tag: 'registered-conditions-table',
  component: 'RegisteredConditionsTable',
  attributes: {
    conditions: {
      type: Object,
      description:
        'An hash of {name: ConditionDocumentation} to display in the table',
    },
  },
};
